import {
  PrimaryButton,
  TertiaryButton,
} from '@changegps/horizon-component-library';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';

import { subscriptionsQueries } from '../data';
import { useUnsubscribeMutation } from '../hooks';
import { useToastStore } from '../store';

interface UnsubscribeDialogProps {
  companyID: string;
  productID: number;
  isVisible: boolean;
  toggleIsVisible: () => void;
}

export const UnsubscribeDialog = ({
  companyID,
  productID,
  isVisible,
  toggleIsVisible,
}: UnsubscribeDialogProps) => {
  const queryClient = useQueryClient();
  const { showToast } = useToastStore();
  const { mutateAsync, isPending } = useUnsubscribeMutation();

  const handleUnsubscribe = async () => {
    try {
      await mutateAsync({ companyID, productID });
      showToast('Unsubscribed successfully!', 'success');
      toggleIsVisible();
      await queryClient.invalidateQueries({
        queryKey: [...subscriptionsQueries.getSubscriptions, companyID],
      });
      await queryClient.invalidateQueries({
        queryKey: [...subscriptionsQueries.getBillingInfo, companyID],
      });
    } catch (error) {
      showToast('Failed to unsubscribe.', 'error');
    }
  };

  return (
    <>
      <Dialog open={isVisible}>
        <DialogTitle>Unsubscribe?</DialogTitle>
        <DialogContent>
          Would you like to unsubscribe from this product? This will take effect
          in your next lock-in period.
        </DialogContent>
        <DialogActions>
          <Stack direction={'row'} spacing={1}>
            <PrimaryButton onClick={handleUnsubscribe} disabled={isPending}>
              {isPending ? 'Unsubscribing...' : 'Yes'}
            </PrimaryButton>
            <TertiaryButton onClick={toggleIsVisible} disabled={isPending}>
              No
            </TertiaryButton>
          </Stack>
        </DialogActions>
      </Dialog>
    </>
  );
};
